import { SearchPopularSearches } from "@nosto/nosto-js/client"
import Heading from "@/elements/Heading/Heading"
import styles from "./Results.module.css"
import PopularSearch from "../Item/PopularSearch"

export type SearchesProps = {
  searches: SearchPopularSearches
}

export default function PopularSearches({ searches }: SearchesProps) {
  if (!searches?.hits?.length) {
    return null
  }

  return (
    <div className={styles.suggestionsColumn}>
      <div className={styles.suggestionGroup}>
        <Heading className={styles.suggestionHeading}>Popular searches</Heading>
        <div className={styles.keywords}>
          {searches.hits.map(search => (
            <PopularSearch key={search.query} search={search} />
          ))}
        </div>
      </div>
    </div>
  )
}
